import * as yup from 'yup';

const validationFields = {
  email: yup
    .string()
    .email('validations.profileSettings.email.invalid')
    .required('validations.profileSettings.email.required')
    .max(50, 'validations.profileSettings.email.maxLength'),
};

export default yup.object().shape({ ...validationFields });



// WEBPACK FOOTER //
// ./src/forms/loanOfficerProfileForm.js